import { fetchMPPUsersStatistics } from '../../../entities/statistics/mppUsers';

export const scope = 'MPP_USERS_STATS';
export const REFRESH_STATS = 'REFRESH_STATS';

export function fetchStatsIfNeeded(payload) {
    return (dispatch, getState) => {
        const { userStats } = getState().app.other.mpp;

        if (!userStats.info.isFetching && userStats.info.needRefresh)
            dispatch(fetchMPPUsersStatistics(payload, scope));
    };
}

export function refreshStats(payload) {
    return (dispatch, getState) => {
        const { userStats } = getState().app.other.mpp;

        if (!userStats.info.isFetching)
            dispatch(fetchMPPUsersStatistics(payload || userStats.info.lastPayload, scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/other/mpp/users.js